import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { buildBreadcrumbs } from './breadcrumbs';
import { useBreadcrumbLabelValue } from './BreadcrumbContext';

/** Breadcrumb của layout chính, tự suy ra từ URL và nhãn do trang chi tiết đăng ký. */
const AppBreadcrumb: React.FC = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const leafLabel = useBreadcrumbLabelValue();

  const breadcrumbs = useMemo(() => buildBreadcrumbs(pathname, { leafLabel }), [pathname, leafLabel]);

  return (
    <BaseBreadcrumb className="tw-bg-surface-container-lowest tw-px-5 tw-pb-2.5 tw-pt-0.5 tw-text-[13px]">
      {breadcrumbs.map((crumb) => (
        <BaseBreadcrumb.Item key={crumb.key}>
          {crumb.url ? <Link to={crumb.url}>{t(crumb.title)}</Link> : t(crumb.title)}
        </BaseBreadcrumb.Item>
      ))}
    </BaseBreadcrumb>
  );
};

export default AppBreadcrumb;
